var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout text-center"},[_c('div',{staticClass:"md-layout-item md-size-50 md-small-size-100"},[_c('h4',{staticClass:"title",attrs:{"slot":"title"},slot:"title"},[_vm._v("404 Page Not Found!")])])])}
var staticRenderFns = []

export { render, staticRenderFns }